module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"message":"You do not have permission to access the resource \u0027{resource}\u0027."},"es-MX":{"message":"No tienes permiso para acceder al recurso \u0027{resource}\u0027."}}')
  delete Component.options._Ctor
}
